import type { FC } from 'react';

interface EmptyStateProps {
  message: string;
}

export const EmptyState: FC<EmptyStateProps> = ({ message }) => {
  return (
    <div className="tc pv4" data-testid="task-target-empty-message">
      <p className="f5 gray">{message}</p>
    </div>
  );
};
